var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import classNames from 'classnames';
import React, { useState } from 'react';
import { externalWitnessSelection } from '../../Shared/MedicationSharedMethods';
import styles from './EditMedicationWitness.module.css';
import { CrossCheckType } from '../../Contracts/MedicationModels';
import { joinLookupIdentifierNamesWithCommas, lookupIdentifierToKey, lookupIdentifierToName } from '../../Shared/SharedModels';
import { PlusIcon } from '../../Components/Icons';
import { primary } from '../../Styles/Colours';
import { ReadOnlyField } from '../../Components/ReadOnlyField';
import { searchWitnesses } from '../../Async/MedicationsOverviewAsync';
import { Tooltip } from '@material-ui/core';
import { useMedicationSettings } from '../../Config/MedicationConfig';
import { ExternalWitnessDialog } from '../ExternalWitnessDialog/ExternalWitnessDialog';
import { FormikStyledSelectAsync } from '../../Components/FormikFields/FormikStyledSelectAsync';
import { useField } from '../../Components/useForm/useField';
function WitnessMenuItem(props) {
    var _a;
    var _b, _c;
    var nameClasses = classNames(styles.name, (_a = {},
        _a[styles.nameSelected] = props.selected,
        _a));
    return (React.createElement("div", { className: styles.witness },
        React.createElement("div", { className: nameClasses }, (_b = props.witness.familyName) === null || _b === void 0 ? void 0 :
            _b.toUpperCase(),
            ", ",
            props.witness.givenName),
        ((_c = props.witness.staffRoles) === null || _c === void 0 ? void 0 : _c.length) > 0 && (React.createElement("div", { className: styles.roles }, joinLookupIdentifierNamesWithCommas(props.witness.staffRoles)))));
}
var renderWitnessMenuItem = function (witness) {
    return React.createElement(WitnessMenuItem, { witness: witness });
};
var renderWitnessSuggestion = function (id) {
    return function renderWitnessSuggestionCurried(witness) {
        var selected = id === witness.id;
        return React.createElement(WitnessMenuItem, { witness: witness, selected: selected });
    };
};
export var EditMedicationWitness = function (props) {
    var medicationSettings = useMedicationSettings();
    var _a = __read(useState(''), 2), externalWitnessDialogName = _a[0], setExternalWitnessDialogName = _a[1];
    var witnessTypeField = useField({ form: props.form, field: 'witnessOneType' });
    var witnessProviderField = useField({ form: props.form, field: 'witnessOneProvider' });
    var witnessNameField = useField({ form: props.form, field: 'witnessOneName' });
    var witnessContactDetailsField = useField({ form: props.form, field: 'witnessOneContactDetails' });
    function getWitnessText(provider) {
        var _a, _b;
        if (witnessTypeField.value === CrossCheckType.External)
            return (_a = witnessNameField.value) !== null && _a !== void 0 ? _a : '';
        var witnessProvider = provider !== null && provider !== void 0 ? provider : witnessProviderField.value;
        if (!witnessProvider)
            return '';
        return ((_b = witnessProvider.familyName) === null || _b === void 0 ? void 0 : _b.toUpperCase()) + ", " + witnessProvider.givenName;
    }
    if (props.readOnly) {
        return (React.createElement("div", null,
            React.createElement(ReadOnlyField, { hideHelperText: true, label: 'Witness', noWrapping: true, tooltipPlacement: 'bottom-start' }, getWitnessText())));
    }
    var renderWitnessSelected = function (witness) {
        var witnessText = getWitnessText(witness);
        return (React.createElement(Tooltip, { title: witnessText !== null && witnessText !== void 0 ? witnessText : '', placement: 'bottom-start' },
            React.createElement("span", { className: styles.witnessSelected }, witnessText)));
    };
    var renderExternalWitnessSelectionButton = function (searchText) {
        if (!searchText)
            return null;
        return (React.createElement("div", { className: styles.externalWitnessItem },
            React.createElement(PlusIcon, { color: primary, size: '24', noPadding: true }),
            React.createElement("span", { className: styles.externalWitnessActionText }, "Record external witness")));
    };
    function handleExternalWitnessResult(save, name, contactDetails) {
        if (save) {
            witnessTypeField.setValue(CrossCheckType.External);
            witnessProviderField.setValue(__assign({}, externalWitnessSelection));
            witnessNameField.setValue(name);
            witnessContactDetailsField.setValue(contactDetails);
        }
        setExternalWitnessDialogName('');
    }
    function handleProviderWitnessSelection() {
        witnessTypeField.setValue(CrossCheckType.Provider);
    }
    function handleActionButton(searchText) {
        setExternalWitnessDialogName(searchText);
    }
    function handleClear() {
        witnessTypeField.setValue(null);
        witnessProviderField.setValue(null);
        witnessNameField.setValue(null);
        witnessContactDetailsField.setValue(null);
    }
    var searchWitnessesWrapper = function (config, query) {
        if (query === void 0) { query = ''; }
        return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, searchWitnesses(config, props.patientMedication.id, query, 6)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        }); });
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(FormikStyledSelectAsync, { name: 'witnessOneProvider', label: 'Witness', maxResults: 5, itemToString: lookupIdentifierToName, itemToMenuKey: lookupIdentifierToKey, fetch: searchWitnessesWrapper, isClearable: true, testId: 'selection-input-witness', customItemRender: props.readOnly ? renderWitnessSelected : renderWitnessMenuItem, suggestionCustomItemRender: renderWitnessSuggestion(witnessProviderField.value ? witnessProviderField.value.id : ''), selectedCustomItemRender: renderWitnessSelected, additionalActionButton: medicationSettings.settings.enableFreeTextWitness
                ? {
                    render: renderExternalWitnessSelectionButton,
                    onSelection: handleActionButton,
                    displayText: function () { return getWitnessText(); }
                }
                : undefined, onSelection: handleProviderWitnessSelection, onClear: handleClear, required: !props.readOnly, readOnly: props.readOnly, useCache: false, hideOptionsWhenReloading: true, noWrapValue: true, optionHeight: 61 }),
        externalWitnessDialogName && (React.createElement(ExternalWitnessDialog, { onClose: handleExternalWitnessResult, initialName: externalWitnessDialogName }))));
};
